<article class="notification" [class.notification--unread]="!notification.isRead" [class.notification--last]="isLast">
  <div class="notification__header">
    <div class="notification__title-container">
      <ac-notification-icon [isUrgent]="notification.isUrgent" [type]="notification.type" />
      <p class="input">
        {{ notification.title }} ·
        <span class="notification__date tag">{{ notification.date | acNotificationDate }}</span>
      </p>
    </div>
    <ac-options-menu [options]="options" />
  </div>
  <p class="notification__text paragraph-m">{{ notification.description }}</p>
  @if (notification.type !== 'MARKET' && notification.type !== 'CONTRACT') {
    <button class="notification__view-btn link-m" (click)="onClickAction()">
      {{ action?.text ?? '' | translate }}
      @if (action?.icon) {
        <ac-icon [name]="action?.icon!" size="small" />
      }
    </button>
  }
</article>
